import { render, staticRenderFns } from "./dangerousGoodsListHAndPSentences.vue?vue&type=template&id=5471c68b&scoped=true"
import script from "./dangerousGoodsListHAndPSentences.vue?vue&type=script&lang=js"
export * from "./dangerousGoodsListHAndPSentences.vue?vue&type=script&lang=js"
import style0 from "./dangerousGoodsListHAndPSentences.vue?vue&type=style&index=0&id=5471c68b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5471c68b",
  null
  
)

export default component.exports